import { AppTooltip } from '@lmt/unicorn-shared/app/components/common/ui-kit/tooltip/AppTooltip';
import React, { FC } from 'react';
import { UniLink } from './ui-kit/buttons/UniLink';
import { ButtonColor } from './ui-kit/buttons/Button';
import clsx from 'clsx';
import { ReactComponent as HintIcon } from '@lmt/unicorn-shared/app/icons/i.svg';

import styles from './Field.module.scss';

export interface FieldLinkProps {
  title: string | React.ReactNode;
  disabled?: boolean;
  icon?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  testId?: string;
  color?: ButtonColor;
}

export interface FieldProps {
  title: string;
  required?: boolean;
  children?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  linkProps?: FieldLinkProps;
  hint?: React.ReactNode;
  testId?: string;
  // use if you want to add 2 fields in a single line, and one of the Fields contain checkbox
  alignCheckbox?: boolean;
}

export const Field: FC<FieldProps> = (props) => {
  const {
    children,
    className,
    linkProps,
    title,
    required,
    titleClassName,
    testId,
  } = props;

  return (
    <div
      className={clsx(
        className,
        props.alignCheckbox && styles.containerAlignCheckbox,
      )}
      data-test-id={testId}
      data-app-field={title}
    >
      <div className={styles.titleContainer}>
        <div className={styles.titleWithHint}>
          <div className={clsx(titleClassName, styles.title)}>{title}</div>
          {required ? <div className={styles.requiredAsterisk}>*</div> : null}
          {props.hint ? (
            <AppTooltip title={props.hint}>
              <div className={styles.hint}>
                <HintIcon />
              </div>
            </AppTooltip>
          ) : null}
        </div>
        {!!linkProps &&
          (typeof linkProps.title === 'string' ? (
            <UniLink
              {...linkProps}
              testId={linkProps.testId ?? 'field-link'}
              title={linkProps.title as string}
              color={linkProps.color ?? ButtonColor.Primary}
              className={clsx(styles.fieldLink, linkProps.className)}
            />
          ) : (
            <span data-test-id={linkProps.testId ?? 'field-link'}>
              {linkProps.title}
            </span>
          ))}
      </div>
      <div
        className={clsx(
          styles.field,
          props.alignCheckbox && styles.fieldAlignCheckbox,
        )}
      >
        {children}
      </div>
    </div>
  );
};
